module.exports = __webpack_public_path__ + "static/media/cq_scarica.088b1668.svg";